<template>
  <d-container fluid class="main-content-container px-4 pb-4">
      <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :loader='"dots"'
        :height='150'
        :width='150'
        :color= '"#F1557A"'
        :is-full-page="fullPage"></loading>
    <v-dialog />
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Manage & Edit</span>
        <h3 class="page-title">Actions</h3>
      </d-col>
    </d-row>
    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card mb-4 card-style">
          <div class="card-header border-bottom">
            <h6 class="m-0">All Actions</h6>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">ID</th>
                  <th scope="col" class="border-0">Title</th>
                  <th scope="col" class="border-0">Description</th>
                  <th scope="col" class="border-0">Type</th>
                  <th scope="col" class="border-0">Donation type</th>
                  <th scope="col" class="border-0">Modify</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="actions.length > 0">
                  <tr v-for="(action, index) in actions" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ action.title }}</td>
                    <td>{{ action.description }}</td>
                    <td>
                      <span class>{{ action.type }}</span>
                    </td>
                    <td>{{ action.donationType ? action.donationType : "none" }}</td>
                    <td v-if="!action.archived">
                      <div style="display:flex;justify-content: flex-start">
                        <d-button
                          class="btn-blue"
                          style="width:100px;"
                          @click.prevent="scrollToEditPanel(action)"
                        >Edit</d-button>
                      </div>
                      <div style="display:flex;justify-content: flex-start">
                        <!-- <d-button
                          @click.prevent="deleteAction(action)"
                          style="width:100px;"
                          class="btn-red mt-2"
                          href="#"
                        >Delete</d-button> -->
                        <d-button
                          @click.prevent="archiveAction(action)"
                          style="width:100px;"
                          class="btn-red mt-2"
                          href="#"
                        >Archive</d-button>
                      </div>
                    </td>
                   <td v-else>
                      <div style="display:flex;justify-content: flex-start">
                        <d-button
                          @click.prevent="ActiveAction(action)"
                          style="width:105px;"
                          class="btn-Green mt-2"
                          href="#"
                        >Activate</d-button>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <h3 class="page-title" v-if="addButton">Add New Action</h3>
        <h3 class="page-title" v-if="!addButton">Edit action</h3>
      </d-col>
    </d-row>

    <d-row>
      <!-- Editor -->
      <div class="edit col-lg-12 col-md-12" ref="editPanel">
        <anp-editor
          selectedTier="selectedTier"
          :selected-action="selectedAction"
          :add-button="addButton"
          @addButtonClick="onAddButtonClick"
        />
      </div>
      <!-- Sidebar Widgets -->
      <d-col lg="3" md="12">
        <!--<anp-sidebar-actions />-->
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import Editor from "@/components/add-new-post/Editor.vue";
import actionsTypes from "../vuex/cta/cta.types";
import { mapState } from "vuex";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "quill/dist/quill.snow.css";
Vue.use(Loading);

export default {
  data() {
    return {
      actions: [],
      addButton: true,
      selectedAction: null,
      selectedTiers: [],
      isLoading: false,
      fullPage: true
    };
  },
  components: {
    anpEditor: Editor,
    Loading
  },
  computed: {
    ...mapState({
      state: state => state.cta.state,
      type: state => state.cta.type,
      data: state => state.cta.data,
      deleted: state => state.cta.deleted,
      updated: state => state.cta.updated,
      added: state => state.cta.added,
      error: state => state.cta.error
    })
  },
  methods: {
    deleteAction(action) {
      const modal = this.$modal;
      const that = this;
      modal.show("dialog", {
        title: "Confirm delete",
        text: "Are you sure you want to delete this supporter?",
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              modal.hide("dialog");
            }
          },
          {
            title: "Delete",
            handler: () => {
              this.$store.dispatch("deleteCTA", action);
            },
            class: "vue-dialog-button delete-btn"
          }
        ]
      });
    },
    archiveAction(action) {
      const modal = this.$modal;
      const that = this;
      modal.show("dialog", {
        title: "Confirm delete",
        text: "Are you sure you want to archive this Action?",
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              modal.hide("dialog");
            }
          },
          {
            title: "Archive",
            handler: () => {
              action.archived = !action.archived 
              this.$store.dispatch("updateCTA", action);

            },
            class: "vue-dialog-button delete-btn"
          }
        ]
      });
    },
    ActiveAction(action) {
      const modal = this.$modal;
      const that = this;
      modal.show("dialog", {
        title: "Confirm delete",
        text: "Are you sure you want to activate this Action again?",
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              modal.hide("dialog");
            }
          },
          {
            title: "Activate",
            handler: () => {
              action.archived = !action.archived 
              this.$store.dispatch("updateCTA", action);

            },
            class: "vue-dialog-button delete-btn"
          }
        ]
      });
    },
    scrollToEditPanel(action) {
      this.$nextTick(function() {
        this.selectedAction = action;
        this.$refs.editPanel.scrollIntoView();
        this.addButton = false;
      });
    },
    onAddButtonClick(addButton, data) {
      if (data) {
        this.$store.dispatch("addCtaAction", data);
        analytics.track("Added Action");
      } else {
        this.addButton = addButton;
      }
    }
  },
  watch: {
    type(newType) {
      if (newType === actionsTypes.FETCH_CTAS_SUCCESS) {
        this.isLoading = false;
        this.actions = this.data.actions;
        this.$toasted.clear();
      } else if (newType === actionsTypes.ADD_CTA_REQUEST) {
        this.isLoading = true;
      } else if (newType === actionsTypes.ADD_CTA_SUCCESS) {
        this.isLoading = false;
        this.$toasted.clear();
        this.$toasted.success("CTA added successfully", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });

        if (this.added) {
          this.actions.push(this.added);
        }
      } else if (newType === actionsTypes.DELETE_CTA_SUCCESS) {
        this.isLoading = false;
        this.$toasted.clear();
        this.$modal.hide("dialog");
        this.$toasted.success("CTA deleted successfully", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });

        for (var i = 0; i < this.actions.length; i++) {
          if (this.actions[i]._id == this.deleted.action._id) {
            this.actions.splice(i, 1);
          }
        }
      } else if (newType === actionsTypes.UPDATE_CTA_SUCCESS) {
        this.isLoading = false;
        this.$modal.hide("dialog");
        this.$toasted.clear();
        this.$toasted.success("CTA Updated Successfully", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });

        if (this.updated) {
          for (var i = 0; i < this.actions.length; i++) {
            if (this.actions[i]._id == this.updated.action._id) {
              this.actions.splice(i, 1, this.updated.action);
            }
          }
        }
      } else if (newType === actionsTypes.FETCH_CTAS_REQUEST) {
        this.isLoading = true;
        // this.$toasted.info("Fetching CTAs...", {
        //   icon: "hourglass_empty",
        //   //duration: 1000,
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true
        //   /*action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }*/
        // });
      } else if (newType === actionsTypes.DELETE_CTA_REQUEST) {
        this.isLoading = true;
        // this.$toasted.clear();
        // this.$modal.hide("dialog");
        // this.$toasted.info("Deleting CTA...", {
        //   icon: "hourglass_empty",
        //   //duration: 1000,
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true
        //   /*action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }*/
        // });
      } else if (newType === actionsTypes.UPDATE_CTA_REQUEST) {
        this.isLoading = true;
        // this.$toasted.info("Updating CTA..", {
        //   icon: "hourglass_empty",
        //   position: "top-center",
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true,
        //   action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }
        // });
      } else if (
        newType === actionsTypes.FETCH_CTAS_FAILED ||
        newType === actionsTypes.ADD_CTA_FAILED ||
        newType === actionsTypes.UPDATE_CTA_FAILED ||
        newType === actionsTypes.DELETE_CTA_FAILED
      ) {
        this.isLoading = false;
        this.$toasted.clear();
        this.$toasted.error(this.error, {
          icon: "error_outline",
          //duration: 1000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
    }
  },
  created() {
    // this.$store.dispatch("fetchTiers");
    this.$store.dispatch("fetchAllCTA");
    analytics.page("Actions");
    // this.$store.dispatch("fetchCtas");
  }
};
</script>
<style>
.type-or-tier {
  padding: 0.4286rem 0.875rem;
  font-size: 0.6875rem;
  line-height: 1.5;
  border-radius: 2.25rem;
  color: white;
  background-image: none;
  border-color: #00b8d8;
  /* opacity: 0.65; */
  background-color: #00b8d8;
  box-shadow: none;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-preview {
  width: 35px;
}
.table td {
  text-align: left;
  vertical-align: middle;
}
.table thead th {
  text-align: left;
  vertical-align: middle;
}
</style>
